import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-add-set-aside-type-confirmation',
    templateUrl: './add-set-aside-type-confirmation.component.html',
    styleUrls: ['./add-set-aside-type-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSetAsideTypeConfirmationComponent {
  setAsideTypes: any;
  newSetAsideType: string;

  constructor(
    public dialogRef: MatDialogRef<AddSetAsideTypeConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      setAsideTypes: any,
      newSetAsideType: string
    }
  ) {
    this.setAsideTypes = data.setAsideTypes;
    this.newSetAsideType = data.newSetAsideType;
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkName(){
    let hasDuplicate = false;
    for(let i = 0; i < this.setAsideTypes.length; i++){
      if(this.setAsideTypes[i].name === this.newSetAsideType){
        hasDuplicate = true;
        break;
      }
    }
    return hasDuplicate;
  }
}
